import {styled} from "@mui/material/styles";
import {Box, Typography} from "@mui/material";

export const AuthorizationTitle = styled(Typography)(() => ({
  fontFamily: 'Inter',
  fontSize: '0.9em',
  fontWeight: '400',
  padding: '0 0 0.7em 0',
  marginBottom: '0.5em',
  marginTop: '0.5em',
}));

export const AuthorizationCardContent = styled(Box)(() => ({
  backgroundColor: '#F5F5F5',
  padding: '0.8em',
  borderRadius: '0.5em',
  marginBottom: '.3em',
}));

export const AuthorizationCardContainer = styled(Box)(() => ({
  padding: '0em 1.5em .2em 1.5em',
}));

export const AuthorizationCardSubtitle = styled(Typography)(() => ({
  fontFamily: 'Inter',
  fontSize: '0.9em',
  fontWeight: '400',
  color: 'rgba(0, 0, 0, 0.6)',
  lineHeight: '1.28em',
  marginTop: '0.2em',
}));
